import { get } from 'lodash';

import {
  PurchaseOrderBillingTooltipResponse,
  PurchaseOrderDeliveryTooltipResponse,
  PurchaseOrderStatusTooltipDocumentViewModel,
  PurchaseOrderStatusTooltipRawDocument,
  PurchaseOrderStatusTooltipViewModel,
} from '../models/purchase-order-status-tooltip.model';

export interface PurchaseOrderStatusTooltipFieldMap {
  doneQuantity: string;
  openQuantity: string;
  documents: string | null;
}

export const PO_BILLING_TOOLTIP_FIELDS: PurchaseOrderStatusTooltipFieldMap = {
  doneQuantity: 'paidQty',
  openQuantity: 'openQty',
  documents: 'linkedInvoices',
};

export const PO_DELIVERY_TOOLTIP_FIELDS: PurchaseOrderStatusTooltipFieldMap = {
  doneQuantity: 'receivedQty',
  openQuantity: 'openQty',
  documents: null,
};

export const PO_TOOLTIP_DOCUMENT_FIELDS = {
  id: 'id',
  runpleId: 'runpleId',
  status: 'status',
};

export function getEmptyPurchaseOrderStatusTooltip(hasError: boolean = false): PurchaseOrderStatusTooltipViewModel {
  return { doneQuantity: null, openQuantity: null, documents: [], hasError };
}

export function mapPurchaseOrderStatusTooltip(
  response: PurchaseOrderBillingTooltipResponse | PurchaseOrderDeliveryTooltipResponse,
  fields: PurchaseOrderStatusTooltipFieldMap
): PurchaseOrderStatusTooltipViewModel {

  const payload = get(response, 'data', response) || {};
  const rawDocuments: PurchaseOrderStatusTooltipRawDocument[] = fields.documents ? get(payload, fields.documents) : null;

  return {
    doneQuantity: toNumberOrNull(get(payload, fields.doneQuantity)),
    openQuantity: toNumberOrNull(get(payload, fields.openQuantity)),
    documents: (Array.isArray(rawDocuments) ? rawDocuments : []).map(mapPurchaseOrderStatusTooltipDocument),
    hasError: false,
  };
}

function mapPurchaseOrderStatusTooltipDocument(rawDocument: PurchaseOrderStatusTooltipRawDocument): PurchaseOrderStatusTooltipDocumentViewModel {
  return {
    id: toNumberOrNull(get(rawDocument, PO_TOOLTIP_DOCUMENT_FIELDS.id)),
    runpleId: get(rawDocument, PO_TOOLTIP_DOCUMENT_FIELDS.runpleId) || '',
    status: get(rawDocument, PO_TOOLTIP_DOCUMENT_FIELDS.status) || '',
  };
}

function toNumberOrNull(value: number | string): number {
  if (value === null || value === undefined || value === '') { return null; }
  const parsed: number = Number(value);
  return isNaN(parsed) ? null : parsed;
}
